import Vue from "vue";
import * as VueGoogleMaps from "gmap-vue";
import GmapCluster from 'gmap-vue/dist/components/cluster'

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyACcwQdnV7Bh3B3Y7qh7m1CrlGQTLnBJ00",
    libraries: "places"
  }
});
 // replace src with dist if you have Babel issues

Vue.component('GmapCluster', GmapCluster)
